import r from "react";
import i from "classnames";
import { LoyaltyProgrammeCodeType as o } from "../../../api/models/loyalty/loyaltyProgramme/loyaltyProgrammeConfiguration/loyaltyProgrammeDesign/loyaltyProgrammeDesignTypes.js";
import { Barcode as n } from "../Barcode/Barcode.js";
import { QrCode as _ } from "../QrCode/QrCode.js";
import a from "./loyaltyScanDisplay.module.scss.js";
function C({
  type: e,
  disabled: t = !1,
  data: l
}) {
  if (!l || e === o.HIDDEN)
    return null;
  const s = e === o.QR_CODE || e === o.QR_AND_BAR_CODE, m = e === o.BAR_CODE || e === o.QR_AND_BAR_CODE;
  return /* @__PURE__ */ r.createElement(
    "div",
    {
      "data-testid": "loyalty-scan-display",
      className: i(
        a.loyaltyScanDisplay,
        {
          [a.loyaltyScanDisplay__disabled]: t,
          [a.loyaltyScanDisplay__both]: e === o.QR_AND_BAR_CODE
        }
      )
    },
    s && /* @__PURE__ */ r.createElement(
      _,
      {
        className: a.qr,
        size: 100,
        data: l
      }
    ),
    m && /* @__PURE__ */ r.createElement(
      n,
      {
        data: l
      }
    )
  );
}
export {
  C as LoyaltyScanDisplay
};
//# sourceMappingURL=LoyaltyScanDisplay.js.map
